import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import location from "./translations/location.json";
import orderReducer from "./translations/orderReducer.json";
import invoiceTrack from "./translations/invoiceTrack.json";
import update from "./translations/update.json";
import header from "./translations/header.json";
import guide from "./translations/guide.json";
import actions from "./translations/actions.json";
import orderPage from "./translations/orderPage.json";
import timePicker from "./translations/timePicker.json";
import general from "./translations/general.json";

i18n
    .use(initReactI18next)
    .init({
    interpolation: { escapeValue: false },  // React already does escaping
    lng: "fa",
    fallbackLng: "fa",
    resources: {
        fa: {
            general,
            location,
            orderReducer,
            invoiceTrack,
            update,
            header,
            guide,
            actions,
            orderPage,
            timePicker
        }
    }
});
export default i18n;